import React, { useState, useEffect } from "react";
import axios from "../../api/axiosConfig";
import Swal from "sweetalert2";
import Pagination from "./../Pagination";
import { io } from "socket.io-client";
import "../../index.css";
import MainLayout from "../MainLayout";

const Users = () => {
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [secondLastName, setSecondLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordCompare, setPasswordCompare] = useState("");
  const [userType, setUserType] = useState("0"); // Valor por defecto para el tipo de usuario
  const [usersList, setUsersList] = useState([]);
  const [sucursalId, setSucursalId] = useState(0);
  const [sucursalIdEdit, setSucursalIdEdit] = useState(0);
  const [sucursalesList, setSucursalesList] = useState([]);
  const [editMode, setEditMode] = useState(null);
  const [totalUsuarios, setTotalUsuarios] = useState(0);
  const [UsersPerPage] = useState(10);
  const [currentUsers, setCurrentUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  //Inputs de edicion
  const [nombreUserEdit, setNombreUserEdit] = useState("");
  const [apellidoPaternoEdit, setApellidoPaternoEdit] = useState("");
  const [apellidoMaternoEdit, setApellidoMaternoEdit] = useState("");
  const [correoUserEdit, setCorreoUserEdit] = useState("");
  const [userTypeEdit, setUserTypeEdit] = useState("0");

  // Estado para el paginado
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchUsers();
    fetchSucursales();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get("/usuarios");
      const fetchedUsers = response.data.data;
      setUsersList(fetchedUsers);

      const totalPages = Math.ceil(fetchedUsers.length / UsersPerPage);
      setTotalUsuarios(totalPages);

      setCurrentUsers(fetchedUsers.slice(0, UsersPerPage));
    } catch (error) {
      console.error("Error fetching users", error);
    }
  };

  const fetchSucursales = () => {
    axios
      .get("/sucursales/active")
      .then((response) => {
        setSucursalesList(response.data.data);
      })
      .catch((error) => {
        console.error("Error al obtener usuarios:", error);
      });
  };

  //Socket that detects new users created
  useEffect(() => {
    const socket = io(process.env.REACT_APP_API_BASE_URL, {
      extraHeaders: {
        "X-4B7F7C13A7D1": process.env.REACT_APP_API_TOKEN,
      },
      transports: ["websocket", "polling"],
    });

    // Escuchar eventos de nuevos clientes
    socket.on("NewUserAdded", () => {
      fetchUsers();
    });

    return () => socket.disconnect(); // Limpiar al desmontar
  }, []);

  //Socket that detects users updated
  useEffect(() => {
    const socket = io(process.env.REACT_APP_API_BASE_URL, {
      extraHeaders: {
        "X-4B7F7C13A7D1": process.env.REACT_APP_API_TOKEN,
      },
      transports: ["websocket", "polling"],
    });

    // Escuchar eventos de nuevos clientes
    socket.on("UpdatedUser", () => {
      fetchUsers();
    });

    return () => socket.disconnect(); // Limpiar al desmontar
  }, []);

  //Socket that detects users Deleted
  useEffect(() => {
    const socket = io(process.env.REACT_APP_API_BASE_URL, {
      extraHeaders: {
        "X-4B7F7C13A7D1": process.env.REACT_APP_API_TOKEN,
      },
      transports: ["websocket", "polling"],
    });

    // Escuchar eventos de nuevos clientes
    socket.on("UserDeleted", () => {
      fetchUsers();
    });

    return () => socket.disconnect(); // Limpiar al desmontar
  }, []);

  //Funcion para filtrar usuarios por nombre de menera flexible
  const filterUsers = (page, searchTermR) => {
    setSearchTerm(searchTermR);
    let registrosIni = (page - 1) * UsersPerPage;

    let filtered = usersList.filter((user) =>
      user.name.toLowerCase().includes(searchTermR.toLowerCase())
    );

    const totalPages = Math.ceil(filtered.length / UsersPerPage);
    setTotalUsuarios(totalPages);

    return filtered.slice(registrosIni, registrosIni + UsersPerPage);
  };

  const handleToggleActive = (userId, userPassword) => {
    // Realizar una solicitud PUT a tu endpoint de activación de usuario
    axios
      .put(`/usuarios/${userId}/activar`, {
        password: userPassword,
      })
      .then((response) => {
        if (response.data.success) {
          // Si la solicitud fue exitosa, actualiza la lista de usuarios
          fetchUsers();
          // Muestra un mensaje de éxito al usuario
          Swal.fire({
            title: "¡Usuario activado!",
            text: "El usuario ha sido activado exitosamente.",
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          // Si la solicitud no fue exitosa, muestra un mensaje de error al usuario
          Swal.fire({
            title: "¡Error!",
            text: "No se pudo activar el usuario.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((error) => {
        // Si hubo un error en la solicitud, muestra un mensaje de error al usuario
        console.error("Error al activar el usuario:", error);
        Swal.fire({
          title: "¡Error!",
          text: "Ocurrió un error al intentar activar el usuario.",
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  const handleToggleDeactive = (userId, userPassword) => {
    // Realizar una solicitud PUT a tu endpoint de desactivación de usuario
    axios
      .put(`/usuarios/${userId}/desactivar`, {
        password: userPassword,
      })
      .then((response) => {
        if (response.data.success) {
          // Si la solicitud fue exitosa, actualiza la lista de usuarios
          fetchUsers();
          // Muestra un mensaje de éxito al usuario
          Swal.fire({
            title: "¡Usuario desactivado!",
            text: "El usuario ha sido desactivado exitosamente.",
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          // Si la solicitud no fue exitosa, muestra un mensaje de error al usuario
          Swal.fire({
            title: "¡Error!",
            text: "No se pudo desactivar el usuario.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((error) => {
        // Si hubo un error en la solicitud, muestra un mensaje de error al usuario
        console.error("Error al desactivar el usuario:", error);
        Swal.fire({
          title: "¡Error!",
          text: "Ocurrió un error al intentar desactivar el usuario.",
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  const handleCreateUser = async () => {
    // Validación de campos vacíos
    if (
      name === "" ||
      lastName === "" ||
      secondLastName === "" ||
      email === "" ||
      password === ""
    ) {
      Swal.fire({
        title: "¡Error al crear usuario!",
        text: "Todos los campos son obligatorios.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    let sessionLimit = null;
    let branchId = null;
    let branchAddress = null;
    let branchNum = null;

    // Solicitar horas de sesión solo si el tipo de usuario no es "Usuario Maestro"
    const sucursalSelected = sucursalesList.find(
      (suc) => suc.id === parseInt(sucursalId)
    );
    branchId = sucursalSelected.id;
    branchAddress = sucursalSelected.direccion;
    branchNum = sucursalSelected.sucursalNumber;

    if (userType !== "0") {
      const { value: formValues } = await Swal.fire({
        title: "Configurar Horas de Sesión",
        html:
          '<input id="start-time" type="time" class="swal2-input" placeholder="Hora de Inicio (AM)">' +
          '<input id="end-time" type="time" class="swal2-input" placeholder="Hora de Fin (PM)">',
        focusConfirm: false,
        preConfirm: () => {
          const startTime = document.getElementById("start-time").value;
          const endTime = document.getElementById("end-time").value;

          return [startTime, endTime];
        },
      });

      if (!formValues) {
        return; // Usuario canceló la acción
      }

      const [startTime, endTime] = formValues;
      sessionLimit = `${startTime}-${endTime}`;
    }

    // Lógica para crear un nuevo usuario
    axios
      .post("/crearUsuario", {
        name,
        lastName,
        secondLastName,
        email,
        password,
        userType,
        sessionLimit,
        branchId,
        branchNum,
        branchAddress,
      })
      .then((response) => {
        if (response.data.success) {
          Swal.fire({
            title: "¡Usuario creado!",
            text: "El nuevo usuario ha sido creado exitosamente.",
            icon: "success",
            confirmButtonText: "OK",
          });
          // Limpiar campos después de la creación exitosa
          setName("");
          setLastName("");
          setSecondLastName("");
          setEmail("");
          setPassword("");
          setUserType("0"); // Restablece el tipo de usuario a su valor por defecto
          // Actualizar la lista de usuarios después de crear uno nuevo
          fetchUsers();
        } else {
          Swal.fire({
            title: "¡Error!",
            text: "No se pudo crear el usuario.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((error) => {
        console.error("Error al crear usuario:", error);
        Swal.fire({
          title: "¡Error!",
          text: "Ocurrió un error al intentar crear el usuario.",
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  const handleDeleteUser = (userId, userPassword) => {
    Swal.fire({
      title: "Eliminar usuario",
      text: "¿Estás seguro de que deseas eliminar al usuario?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`/usuarios/${userId}`)
          .then((response) => {
            if (response.data.success) {
              // Si la solicitud fue exitosa, actualiza la lista de usuarios
              fetchUsers();
              // Muestra un mensaje de éxito al usuario
              Swal.fire({
                title: "¡Usuario eliminado!",
                text: "El usuario ha sido eliminado exitosamente.",
                icon: "success",
                confirmButtonText: "OK",
              });
            } else {
              // Si la solicitud no fue exitosa, muestra un mensaje de error al usuario
              Swal.fire({
                title: "¡Error!",
                text: "No se pudo eliminar el usuario.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch((error) => {
            // Si hubo un error en la solicitud, muestra un mensaje de error al usuario
            console.error("Error al eliminar el usuario:", error);
            Swal.fire({
              title: "¡Error!",
              text: "Ocurrió un error al intentar eliminar el usuario.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      } else {
        Swal.close();
      }
    });
  };

  const handleEditUser = async (userId, userPassword) => {
    if (editMode === userId) {
      setEditMode(null);
      const editedUser = usersList.find((user) => user.id === userId);
      if (sucursalIdEdit != 0) {
        const sucursalSelected = sucursalesList.find(
          (suc) => suc.id === parseInt(sucursalIdEdit)
        );
        editedUser.branchId = sucursalSelected.id;
        editedUser.branchAddress = sucursalSelected.direccion;
        editedUser.branchNum = sucursalSelected.sucursalNumber;
        setSucursalIdEdit(0);
      } else {
        setSucursalIdEdit(editedUser.branchId);
      }

      const isAnyFieldEmpty = Object.values(editedUser).some(
        (value) => value === ""
      );

      if (isAnyFieldEmpty) {
        Swal.fire({
          title: "¡Error!: Faltan datos",
          text: "Todos los campos son obligatorios.",
          icon: "error",
          confirmButtonText: "OK",
        });
        fetchUsers();
        return;
      }

      if (editedUser.password === passwordCompare) {
        editedUser.password = null;
      }

      await axios.put(`/usuarios/${userId}`, editedUser, {
        data: { password: editedUser.password },
      });
      // Mostrar un mensaje de éxito al usuario
      Swal.fire({
        title: "¡Usuario actualizado!",
        text: "Los cambios se han guardado exitosamente.",
        icon: "success",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      }).then(() => {
        if (sucursalIdEdit != 0) {
          const sucursalSelected = sucursalesList.find(
            (suc) => suc.id === parseInt(sucursalIdEdit)
          );
          if (editedUser.id == localStorage.getItem("idUser")) {
            const branchId = sucursalSelected.id;
            localStorage.setItem("branchId", branchId);
          }
        }
        window.location.reload();
      });
      setSucursalIdEdit(0);
    } else {
      // Activar el modo de edición para el usuario con el ID proporcionado
      setEditMode(userId);
      const editedUser = usersList.find((user) => user.id === userId);
      setNombreUserEdit(editedUser.name || "");
      setApellidoPaternoEdit(editedUser.lastName || "");
      setApellidoMaternoEdit(editedUser.secondLastName || "");
      setCorreoUserEdit(editedUser.email || "");
      setUserTypeEdit(editedUser.userType || 0);
      setPasswordCompare(editedUser.password || "");
    }
  };

  const handleEditInputChange = (e, userId, field) => {
    const { value } = e.target;

    if (field === "name") {
      setNombreUserEdit(value);
      setUsersList(
        usersList.map((user) =>
          user.id === userId ? { ...user, [field]: value } : user
        )
      );
    } else if (field === "lastName") {
      setApellidoPaternoEdit(value);
      setUsersList(
        usersList.map((user) =>
          user.id === userId ? { ...user, [field]: value } : user
        )
      );
    } else if (field === "secondLastName") {
      setApellidoMaternoEdit(value);
      setUsersList(
        usersList.map((user) =>
          user.id === userId ? { ...user, [field]: value } : user
        )
      );
    } else if (field === "email") {
      setCorreoUserEdit(value);
      setUsersList(
        usersList.map((user) =>
          user.id === userId ? { ...user, [field]: value } : user
        )
      );
    } else if (field === "userType") {
      setUserTypeEdit(value);
      setUsersList(
        usersList.map((user) =>
          user.id === userId ? { ...user, [field]: value } : user
        )
      );
    } else {
      setUsersList(
        usersList.map((user) =>
          user.id === userId ? { ...user, [field]: value } : user
        )
      );
    }
  };
  const userTypeText = (type) => {
    switch (type) {
      case "0":
        return "Usuario Maestro";
      case "1":
        return "Usuario Encargado";
      case "2":
        return "Usuario de Caja";
      case "3":
        return "Usuario de Laboratorio";
      case "4":
        return "Usuario Optometrista";
      default:
        return "Indefinido";
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    return date.toLocaleDateString("es-ES", options);
  };

  const handleSetPassword = async (userId) => {
    const { value: password } = await Swal.fire({
      title: "Ingresar nueva contraseña",
      input: "text",
      inputPlaceholder: "Ingrese nueva contraseña",
      inputAttributes: {
        maxlength: 20,
        autocapitalize: "off",
        autocorrect: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      preConfirm: (password) => {
        if (!password) {
          Swal.showValidationMessage("La contraseña no puede estar vacía");
          return false;
        }
        return password;
      },
    });

    if (password) {
      const updatedUsersList = usersList.map((user) => {
        if (user.id === userId) {
          return { ...user, password };
        }
        return user;
      });
      setUsersList(updatedUsersList);
      Swal.fire({
        title: "¡Contraseña actualizada!",
        text: "Confirme cambios dando click en guardar.",
        icon: "success",
        confirmButtonText: "OK",
      });
    }
  };

  const handleSetSessionLimit = async (userId) => {
    const { value: formValues } = await Swal.fire({
      title: "Configurar Horas de Sesión",
      html:
        'Inicio: <input id="start-time" type="time" class="swal2-input" placeholder="Hora de Inicio (AM)">' +
        '<br>Final: <input id="end-time" type="time" class="swal2-input" placeholder="Hora de Fin (PM)">',
      focusConfirm: false,
      preConfirm: () => {
        const startTime = document.getElementById("start-time").value;
        const endTime = document.getElementById("end-time").value;

        return [startTime, endTime];
      },
    });

    if (formValues) {
      const [startTime, endTime] = formValues;
      const sessionLimit = `${startTime}-${endTime}`;

      await axios.put(`/users/${userId}/session-limit`, {
        sessionLimit,
      });

      Swal.fire(`Horas de sesión configuradas: ${sessionLimit}`);
      fetchUsers();
    }
  };

  // Función para verificar si una hora es AM
  const isAM = (time) => {
    const [hour, minute] = time.split(":");
    const hourInt = parseInt(hour, 10);
    return hourInt >= 0 && hourInt < 12;
  };

  // Función para verificar si una hora es PM
  const isPM = (time) => {
    const [hour, minute] = time.split(":");
    const hourInt = parseInt(hour, 10);
    return hourInt >= 12 && hourInt < 24;
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setCurrentUsers(filterUsers(page, searchTerm));
  };

  return (
    <MainLayout>
        <div style={{ margin: "0 auto" }}>
          <div className="">
            {/* Columna 1 */}
            <div
              className="col-md-6"
              style={{ color: "black", margin: "0 auto" }}
            >
              <h2>Crear Nuevo Usuario</h2>
              <form
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "10px",
                }}
              >
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">
                    Nombre
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Ingresa el nombre"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="lastName" className="form-label">
                    Apellido Paterno
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="lastName"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    placeholder="Ingresa el apellido paterno"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="secondLastName" className="form-label">
                    Apellido Materno
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="secondLastName"
                    value={secondLastName}
                    onChange={(e) => setSecondLastName(e.target.value)}
                    placeholder="Ingresa el apellido materno"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Correo Electrónico
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id=""
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Ingresa el correo electrónico"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">
                    Contraseña
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Ingresa la contraseña"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="userType" className="form-label">
                    Tipo de Usuario
                  </label>
                  <select
                    className="form-select"
                    id="userType"
                    value={userType}
                    onChange={(e) => setUserType(e.target.value)}
                  >
                    <option value="0">Usuario Maestro</option>
                    <option value="1">Usuario Encargado</option>
                    <option value="2">Usuario de Caja</option>
                    <option value="3">Usuario de Laboratorio</option>
                    <option value="4">Usuario Optometrista</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label htmlFor="sucursal" className="form-label">
                    Sucursal
                  </label>
                  <select
                    className="form-select"
                    id="sucursal"
                    value={sucursalId}
                    onChange={(e) => setSucursalId(e.target.value)}
                  >
                    <option value="">Selecciona una sucursal</option>
                    {sucursalesList.map((suc) => (
                      <option key={suc.id} value={suc.id}>
                        {`${suc.sucursalNumber} - ${suc.direccion}`}
                      </option>
                    ))}
                  </select>
                </div>
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{
                    width: "fit-content",
                    height: "fit-content",
                    alignSelf: "center",
                    justifySelf: "center",
                  }}
                  onClick={handleCreateUser}
                >
                  Crear Usuario
                </button>
              </form>
            </div>

            {/* Columna 2 */}
            <div className="" style={{ padding: "0 30px" }}>
              <h2 style={{ color: "black" }}>Lista de Usuarios</h2>
              <table
                className="table table-dark"
                style={{ borderRadius: "20px" }}
              >
                <thead>
                  <tr>
                    <th style={{ borderTopLeftRadius: "20px" }}>Sucursal</th>
                    <th>Nombre</th>
                    <th>Apellido Paterno</th>
                    <th>Apellido Materno</th>
                    <th>Correo Electrónico</th>
                    <th>Tipo de Usuario</th>
                    {editMode == null ? <th>Ultima sesión</th> : ""}
                    {editMode == null ? <th>Limite de sesión</th> : ""}

                    <th>Acciones</th>
                    {editMode == null ? (
                      <th style={{ borderTopRightRadius: "20px" }}></th>
                    ) : (
                      ""
                    )}
                  </tr>
                </thead>
                <tbody>
                  {currentUsers.map((user, index) => (
                    <tr key={index}>
                      {editMode === user.id ? (
                        <td>
                          <select
                            className="form-select"
                            id="sucursal"
                            value={sucursalIdEdit}
                            onChange={(e) => setSucursalIdEdit(e.target.value)}
                          >
                            <option value="">Selecciona una sucursal</option>
                            {sucursalesList.map((suc) => (
                              <option key={suc.id} value={suc.id}>
                                {`${suc.sucursalNumber} - ${suc.direccion}`}
                              </option>
                            ))}
                          </select>
                        </td>
                      ) : (
                        <td>{user.branchNum}</td>
                      )}
                      <td>
                        {editMode === user.id ? (
                          <input
                            type="text"
                            className="form-control"
                            value={nombreUserEdit}
                            onChange={(e) =>
                              handleEditInputChange(e, user.id, "name")
                            }
                          />
                        ) : (
                          user.name
                        )}
                      </td>
                      <td>
                        {editMode === user.id ? (
                          <input
                            type="text"
                            className="form-control"
                            value={apellidoPaternoEdit}
                            onChange={(e) =>
                              handleEditInputChange(e, user.id, "lastName")
                            }
                          />
                        ) : (
                          user.lastName
                        )}
                      </td>
                      <td>
                        {editMode === user.id ? (
                          <input
                            type="text"
                            className="form-control"
                            value={apellidoMaternoEdit}
                            onChange={(e) =>
                              handleEditInputChange(
                                e,
                                user.id,
                                "secondLastName"
                              )
                            }
                          />
                        ) : (
                          user.secondLastName
                        )}
                      </td>
                      <td>
                        {editMode === user.id ? (
                          <input
                            type="email"
                            className="form-control"
                            value={correoUserEdit}
                            onChange={(e) =>
                              handleEditInputChange(e, user.id, "email")
                            }
                          />
                        ) : (
                          user.email
                        )}
                      </td>
                      <td>
                        {editMode === user.id ? (
                          <select
                            value={userTypeEdit}
                            className="form-control"
                            onChange={(e) =>
                              handleEditInputChange(e, user.id, "userType")
                            }
                          >
                            <option value="0">Usuario Maestro</option>
                            <option value="1">Usuario Encargado</option>
                            <option value="2">Usuario de Caja</option>
                            <option value="3">Usuario de Laboratorio</option>
                            <option value="4">Usuario Optometrista</option>
                          </select>
                        ) : (
                          userTypeText(user.userType)
                        )}
                      </td>

                      {editMode === user.id ? (
                        <td>
                          <button
                            className="btn btn-dark"
                            onClick={() => handleSetPassword(user.id)}
                            style={{ whiteSpace: "nowrap" }}
                          >
                            Nueva contraseña
                          </button>
                        </td>
                      ) : (
                        ""
                      )}

                      {editMode == null ? (
                        <td>
                          {user.lastSessionDate
                            ? formatDate(user.lastSessionDate)
                            : "-"}
                        </td>
                      ) : (
                        ""
                      )}

                      {editMode == null ? <td>{user.sessionLimit}</td> : ""}

                      {editMode === user.id ? (
                        <td>
                          <button
                            className="btn btn-secondary"
                            onClick={() => handleSetSessionLimit(user.id)}
                            style={{ whiteSpace: "nowrap" }}
                          >
                            Hora de Sesión
                          </button>
                        </td>
                      ) : (
                        ""
                      )}

                      <td>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 1fr",
                            gap: "5px",
                          }}
                        >
                          <button
                            className="btn btn-primary"
                            onClick={() => handleEditUser(user.id)}
                          >
                            {editMode === user.id ? "Guardar" : "Editar"}
                          </button>
                          {editMode !== user.id ? (
                            <>
                              <button
                                className={`btn ${
                                  user.active ? "btn-warning" : "btn-success"
                                }`}
                                onClick={() => {
                                  if (user.active) {
                                    handleToggleDeactive(user.id);
                                  } else {
                                    handleToggleActive(user.id);
                                  }
                                }}
                              >
                                {user.active ? "Desactivar" : "Activar"}
                              </button>
                              <button
                                className="btn btn-danger"
                                onClick={() => handleDeleteUser(user.id)}
                              >
                                Eliminar
                              </button>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* Paginación */}
              <Pagination
                totalPages={totalUsuarios}
                itemsPerPage={10}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
    </MainLayout>
  );
};

export default Users;
